import { useQuery } from '@tanstack/react-query';
import { QueryConfig, ExtractFnReturnType } from '../../../../lib/react-query';
import i18n from '../../../../i18n';
import { getClaimDeleteReasonSelect } from '../api/claimDeleteReason';




type QueryFnType = typeof getClaimDeleteReasonSelect;

type UseClaimDeleteReasoSelectOptions = { 
  config?: QueryConfig<QueryFnType>;
};

export const useClaimDeleteReasonSelect = ({ config = {} }: UseClaimDeleteReasoSelectOptions) => {
    return useQuery<ExtractFnReturnType<QueryFnType>>({
        ...config,
        queryKey: ['claimDeleteReasonSelect', i18n.language],
        queryFn: () => getClaimDeleteReasonSelect(), //
        refetchOnMount: false,
        refetchOnWindowFocus: false,
    });
};